module.exports = __webpack_public_path__ + "static/img/13.00a1b29.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/3/eng/13.png
// module id = 6mVE
// module chunks = 0